import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { TableDataSource } from '../../shared/editable-mat-table/table-data-source';
import { BusinessHoursValidatorService } from './business-hours-validator.service';
import { BusinessHours } from '../models/business-hours.model';
import { Business } from '../models/business.model';
import { BusinessHoursService } from '../services/business-hours.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var BusinessHoursTableComponent = /** @class */ (function () {
    function BusinessHoursTableComponent(hoursValidator, _hoursService, _businessManagerService) {
        this.hoursValidator = hoursValidator;
        this._hoursService = _hoursService;
        this._businessManagerService = _businessManagerService;
        this.businessHoursChange = new EventEmitter();
        this.daysOfTheWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        this.displayCols = ['fromMmDd', 'toMmDd', 'fromWeekDay', 'toWeekDay', 'fromTime', 'toTime', 'actionsCol'];
    }
    BusinessHoursTableComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setBusinessHours();
                return [2 /*return*/];
            });
        });
    };
    BusinessHoursTableComponent.prototype.ngOnDestroy = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.dataSource.datasourceSubject.unsubscribe();
                return [2 /*return*/];
            });
        });
    };
    BusinessHoursTableComponent.prototype.addNewRow = function () {
        this.dataSource.createNew();
    };
    BusinessHoursTableComponent.prototype.startEdit = function (row) {
        row.startEdit();
    };
    BusinessHoursTableComponent.prototype.confirmEditOrCreate = function (row) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (row.validator.valid) {
                    if (row.shouldCreate) {
                        this.createBusinessHours(this.business.id, row.currentData);
                    }
                    else {
                        this.updateBusinessHours(this.business.id, row.currentData);
                    }
                }
                row.confirmEditCreate();
                return [2 /*return*/];
            });
        });
    };
    BusinessHoursTableComponent.prototype.cancelOrDelete = function (row) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (row.shouldDelete) {
                    this.deleteBusinessHour(row.currentData);
                }
                row.cancelOrDelete();
                return [2 /*return*/];
            });
        });
    };
    //#region Service Calls
    BusinessHoursTableComponent.prototype.createBusinessHours = function (businessId, bHrs) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bHours;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._hoursService.createBusinessHours(businessId, bHrs)];
                    case 1:
                        bHours = _a.sent();
                        if (!this.business.hours) { // Previously the business never had custom hours
                            this.business.hours = new Array();
                        }
                        this.business.hours.push(bHours);
                        return [4 /*yield*/, this.updateTheBusiness()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessHoursTableComponent.prototype.updateBusinessHours = function (businessId, hours) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hoursId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hoursId = hours.id;
                        this.business.hours.splice(this.business.hours.indexOf(hours), 1);
                        return [4 /*yield*/, this._hoursService.updateBusinessHours(businessId, hoursId, hours)
                                .then(function (bHours) {
                                _this.business.hours.push(bHours);
                                _this.updateTheBusiness();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessHoursTableComponent.prototype.deleteBusinessHour = function (hours) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hours.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._hoursService.deleteBusinessHours(this.business.id, hours.id)
                                .then(function () {
                                _this.business.hours = _this.business.hours.filter(function (bH) { return bH.id !== hours.id; });
                                _this.updateTheBusiness();
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BusinessHoursTableComponent.prototype.updateTheBusiness = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newBusiness;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 1:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessHoursTableComponent.prototype.setBusinessHours = function () {
        var _this = this;
        this.dataSource = new TableDataSource(this.business.hours, BusinessHours, this.hoursValidator);
        this.dataSource.datasourceSubject.subscribe(function (bHrs) { return _this.businessHoursChange.emit(bHrs); });
    };
    //#endregion
    BusinessHoursTableComponent.prototype.hasUnsavedChanges = function () {
        return this.dataSource.hasUnsavedRow();
    };
    return BusinessHoursTableComponent;
}());
export { BusinessHoursTableComponent };
